<div class="layout-topbar">
  <div class="layout-topbar-wrapper">
    <div class="layout-topbar-left">
      <div class="layout-topbar-logo-wrapper">
        <a class="layout-topbar-logo" [class.light]="!appMain.darkMode" routerLink="/">&nbsp;</a>
      </div>
      <a href="#" class="sidebar-menu-button" (click)="appMain.onMenuButtonClick($event)">
        <i class="mdi mdi-menu"></i>
      </a>
      <a href="#" class="topbar-menu-mobile-button" (click)="appMain.onTopbarMobileMenuButtonClick($event)">
        <i class="mdi mdi-dots-vertical"></i>
      </a>
    </div>
    <div class="layout-topbar-right fadeInDown">
      <ul class="layout-topbar-actions">
        <li #message class="topbar-item" [ngClass]="{'active-topmenuitem': appMain.activeTopbarItem === message}">
          <a href="#" (click)="appMain.onTopbarItemClick($event,message)">
            <i pBadge class="topbar-icon mdi mdi-email-outline" [value]="($messages | async)?.length.toString()"></i>
          </a>
          <ul class="fadeInDown">
            @for (m of $messages | async; track m; let i = $index) {
              <li class="layout-submenu-item">
                <a class="menu-text" (click)="setSelectedMessage(m.id)">
                  <p>{{ m.title }}</p>
                </a>
                <i class="mdi mdi-chevron-right"></i>
              </li>
            }
            <hr/>
            <li class="layout-submenu-item mb-3">
              <a routerLink="/messages" class="menu-text">
                <b i18n>See all messages</b>
              </a>
              <i class="mdi mdi-format-line-spacing"></i>
            </li>
          </ul>
        </li>
        @if (profile) {
          <li #desktopProfile class="topbar-item profile-item" [ngClass]="{'active-topmenuitem': appMain.activeTopbarItem === desktopProfile}">
            <a href="#" (click)="appMain.onTopbarItemClick($event,desktopProfile)">
              <span class="profile-image-wrapper">
                @if (profile.avatar?.id) {
                  <img [attr.src]="image?.full" class="avatar"/>
                } @else {
                  <i class="mdi mdi-48px mdi-account-circle"></i>
                }
              </span>
              <span class="profile-info-wrapper">
                <h3>{{ profile.lastName }} {{ profile.firstName }}</h3>
              </span>
            </a>
            <ul class="profile-item-submenu fadeInDown">
              <li class="submenu-actions">
                <!--btton pButton [routerLink]="['/account']" label="Profile" i18n-label></!button-->
                <button pButton (click)="appMain.configActive = true" label="Settings" i18n-label></button>
                <button pButton (click)="logout($event)" label="Sign Out" i18n-label></button>
              </li>
            </ul>
          </li>
        }
      </ul>
      @if (profile) {
        <ul class="profile-mobile-wrapper">
          <li #mobileProfile class="topbar-item profile-item" [ngClass]="{'active-topmenuitem': appMain.activeTopbarItem === mobileProfile}">
            <a href="#" (click)="appMain.onTopbarItemClick($event,mobileProfile)">
              <span class="profile-image-wrapper">
                @if (profile.avatar?.id) {
                  <img [attr.src]="image?.full" class="avatar" />
                } @else {
                  <i class="mdi mdi-48px mdi-account-circle"></i>
                }
              </span>
              <span class="profile-info-wrapper">
                <h3>{{ profile.lastName }} {{ profile.firstName }}</h3>
              </span>
            </a>
          </li>
        </ul>
      }
    </div>
  </div>
</div>
